import * as ActionType from '../constants/ActionType'
import * as api from '../api/api';
import * as userAction from './user';

/**
 * Action creators
 **/

function requestCampaigns() {
    return {
        type: ActionType.REQUEST_CAMPAIGNS
    }
}

function receiveCampaigns(json) {
    return {
        type: ActionType.RECEIVE_CAMPAIGNS,
        json: json
    }
}

export function getCampaigns() {
    return (dispatch, getState) => {
        if (areCampaignsLoaded(getState()) ) {
            // Let the calling code know there's nothing to wait for.
            return Promise.resolve();
        } else {
            // Dispatch a thunk from thunk!
            return dispatch(fetchCampaings());
        }
    };
}

function areCampaignsLoaded(globalState) {
    return globalState.campaign.loaded;
}

// @see : http://redux.js.org/docs/advanced/AsyncActions.html
function fetchCampaings() {

    // Thunk middleware knows how to handle functions.
    // It passes the dispatch method as an argument to the function,
    // thus making it able to dispatch actions itself.

    return function (dispatch, getState) {

        if (!userAction.isUserAuthenticated(getState())) {
            return dispatch(userAction.loginRequired());
        }

        // First dispatch: the app state is updated to inform
        // that the API call is starting.

        dispatch(requestCampaigns())

        // The function called by the thunk middleware can return a value,
        // that is passed on as the return value of the dispatch method.

        // In this case, we return a promise to wait for.
        // This is not required by thunk middleware, but it is convenient for us.

        return api.getCampaignGroups()
            .then(function(response) {
                return api.handleStatus(response, dispatch)
            })
            .then(data => {
                dispatch(receiveCampaigns(data));
            })
            // .catch(error => {
            //     console.log(`Request failed: ${error}`);
            // })
            ;
        // In a real world app, you also want to
        // catch any error in the network call.
    }
}


// WEBPACK FOOTER //
// ./src/js/actions/campaign.js